import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';
import { Alert } from '@mui/material';
import { showModalStateFinance, selectedTransactionStateFinance } from '../state/FinanceUIStateJ';
import { TransactionModals } from '../Transactions/modals/TransactionModals';
import { forceAllTransactionsByDateUpdateJ } from '../state/FinanceStateJ';
import { AllTransactionsGrid } from './AllTransactionsGrid';
import { useAllTransactionsData } from './useAllTransactionsData';
import { AllTransactionFilters } from './AllTransactionFilters';
import { useResetTransactionFilters } from './AllTransactionsFilterStateJ';

export function AllTransactions() {
  const resetFilters = useResetTransactionFilters();

  useEffect(() => {
    return resetFilters;
  }, [resetFilters]);

  return <AllTransactionsContent />;
}

export function AllTransactionsContent() {
  const setModalState = useSetAtom(showModalStateFinance);
  const setSelectedTransaction = useSetAtom(selectedTransactionStateFinance);
  const forceRefetchCount = useAtomValue(forceAllTransactionsByDateUpdateJ);
  const { error, allTransactions } = useAllTransactionsData({ forceRefetchCount });

  useEffect(() => {
    return () => {
      setModalState(null);
      setSelectedTransaction(null);
    };
  }, [setModalState, setSelectedTransaction]);

  if (error) {
    return <Alert severity='error'>Error fetching transactions</Alert>;
  }

  return (
    <>
      <AllTransactionFilters />
      <AllTransactionsGrid transactions={allTransactions} />
      <TransactionModals />
    </>
  );
}
